module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_1-44c94875929ba5842d9fe064d45cb6a4.jpg";